var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterviewPassed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99935 18.3337C14.6017 18.3337 18.3327 14.6027 18.3327 10.0003C18.3327 5.39795 14.6017 1.66699 9.99935 1.66699C5.39698 1.66699 1.66602 5.39795 1.66602 10.0003C1.66602 14.6027 5.39698 18.3337 9.99935 18.3337ZM13.8609 8.65356C14.2677 8.24677 14.2677 7.58722 13.8609 7.18042C13.4541 6.77363 12.7946 6.77363 12.3878 7.18042L8.95768 10.6105L7.61092 9.26376C7.20412 8.85696 6.54458 8.85696 6.13778 9.26376C5.73098 9.67055 5.73098 10.3301 6.13778 10.7369L8.22111 12.8202C8.62791 13.227 9.28746 13.227 9.69425 12.8202L13.8609 8.65356Z",
    fill: "#399D81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewPassed);
export default __webpack_public_path__ + "static/media/interview-passed.f24618e3c84db31ac566faadba1e2b8b.svg";
export { ForwardRef as ReactComponent };